"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Team = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const schema_1 = require("lincd-schema/lib/ontologies/schema");
const irlcg_1 = require("../ontologies/irlcg");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const Organization_1 = require("lincd-schema/lib/shapes/Organization");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const Person_1 = require("lincd-schema/lib/shapes/Person");
const Meeting_1 = require("./Meeting");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
let Team = class Team extends Organization_1.Organization {
    get meetings() {
        return Meeting_1.Meeting.getSetOf(this.getAll(irlcg_1.irlcg.Meeting));
    }
    get teamLeaderMessage() {
        return this.getValue(irlcg_1.irlcg.teamLeaderMessage);
    }
    set teamLeaderMessage(val) {
        this.overwrite(irlcg_1.irlcg.teamLeaderMessage, new models_1.Literal(val));
    }
    // I created team leader as property replacing team founder that use as admin
    get teamLeader() {
        return this.getOneAs(irlcg_1.irlcg.teamLeader, Person_1.Person);
    }
    set teamLeader(val) {
        this.overwrite(irlcg_1.irlcg.teamLeader, val.namedNode);
    }
    get nextMeetingDate() {
        return XSDDate_1.XSDDate.toNativeDate(this.getOne(irlcg_1.irlcg.nextMeetingDate));
    }
    set nextMeetingDate(val) {
        this.overwrite(irlcg_1.irlcg.nextMeetingDate, XSDDate_1.XSDDate.fromNativeDate(val).node);
    }
    static addUserToTeam(teamId, user, removeFromOtherTeams = true, setCurrentTeam = true) {
        return Server_1.Server.call(this, 'addUserToTeam', teamId, user, removeFromOtherTeams, setCurrentTeam);
    }
    static getAllAccounts() {
        return Server_1.Server.call(this, 'getAllAccounts');
    }
    static getTeamMeeting() {
        return Server_1.Server.call(this, 'getTeamMeeting');
    }
    static getAllUserInTheTeam() {
        return Server_1.Server.call(this, 'getAllUserInTheTeam');
    }
    static getAllTeamsIdentifiers() {
        return Server_1.Server.call(this, 'getAllTeamsIdentifiers');
    }
    static getAllTeams() {
        return Server_1.Server.call(this, 'getAllTeams');
    }
    static getUserTeams(user) {
        return Server_1.Server.call(this, 'getUserTeams', user);
    }
    static getUserEventTeams(user) {
        return Server_1.Server.call(this, 'getUserEventTeams', user);
    }
    static getTeamOfUser() {
        return Server_1.Server.call(this, 'getTeamOfUser');
    }
    static getTeamById(teamId) {
        return Server_1.Server.call(this, 'getTeamById', teamId);
    }
    static getTeamMembersByTeamId(teamId) {
        return Server_1.Server.call(this, 'getTeamMembersByTeamId', teamId);
    }
    static getTeamOf(person) {
        return Server_1.Server.call(this, 'getTeamOf', person);
    }
    static getCurrentTeamOf(player) {
        return Server_1.Server.call(this, 'getCurrentTeamOf', player);
    }
    static createTeam() {
        return Server_1.Server.call(this, 'createTeam');
    }
    static createTeamMeeting(form) {
        return Server_1.Server.call(this, 'createTeamMeeting', form);
    }
    static getTeamLeader() {
        return Server_1.Server.call(this, 'getTeamLeader');
    }
    static assignUserAsTeamLeader(teamId, user) {
        return Server_1.Server.call(this, 'assignUserAsTeamLeader', teamId, user);
    }
    static isUserTeamLeaderOnCurrentTeam() {
        return Server_1.Server.call(this, 'isUserTeamLeaderOnCurrentTeam');
    }
    static addTeamMate(firstName, lastName, teamID) {
        return Server_1.Server.call(this, 'addTeamMate', firstName, lastName, teamID);
    }
    /**
     * returns a map of the team participation for each topic
     * the value is the percentage of team members that have participated in the topic (0-100)
     * @param team if not given the current user's team is used
     */
    static getTeamParticipation(team) {
        return Server_1.Server.call(this, 'getTeamParticipation', team);
    }
    static getTeamStatistics() {
        return Server_1.Server.call(this, 'getTeamStatistics');
    }
    static moveTeamMembersToAnotherTeam(user, teamId, newTeamId) {
        return Server_1.Server.call(this, 'moveTeamMembersToAnotherTeam', user, teamId, newTeamId);
    }
    static addUserToAction(user) {
        return Server_1.Server.call(this, 'addUserToAction', user);
    }
    static removeTeamMate(user, teamId) {
        return Server_1.Server.call(this, 'removeTeamMate', user, teamId);
    }
};
exports.Team = Team;
Team.targetClass = schema_1.schema.Organization;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.Meeting,
        shape: Meeting_1.Meeting,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], Team.prototype, "meetings", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.teamLeaderMessage,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Team.prototype, "teamLeaderMessage", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.teamLeader,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], Team.prototype, "teamLeader", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.nextMeetingDate,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Team.prototype, "nextMeetingDate", null);
exports.Team = Team = __decorate([
    package_1.linkedShape
], Team);
//# sourceMappingURL=Team.js.map